import React, { InputHTMLAttributes, useState } from "react";
import styled from "styled-components";
import Typography from "../typography";
import { Colors } from "../../utils/colors";
import InputLock from "components/tool-tips/tool/input-lock";
import UpgradeToPro from "components/tool-tips/tips/upgradeToPro";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
  status?: string; //error
  disabled?: boolean;
  lockIcon?: boolean;
  padding?: string;
  lockTip?: "upgrade" | "default";
}
const TextInput = ({
  label,
  required,
  status = "default",
  disabled,
  lockIcon = disabled,
  padding,
  lockTip = "default",
  ...rest
}: IProps) => {
  const [focused, setFocused] = useState(false);

  const Tips = { upgrade: <UpgradeToPro />, default: <></> };
  return (
    <Container>
      {label && (
        <Typography color="#CDCDCD" weight="medium" mb="0.4" align="left">
          {label}
          {required && "*"}
        </Typography>
      )}
      <InputContainer
        status={status}
        focused={focused ? "true" : "false"}
        padding={padding}
        disabled={disabled ? "true" : "false"}
      >
        <Input
          icon={disabled && lockIcon ? "true" : "false"}
          status={status}
          {...rest}
          onFocus={() => {
            setFocused(true);
          }}
          disabled={disabled}
          onBlur={() => setFocused(false)}
        />
        {disabled && lockIcon && <InputLock tip={Tips[lockTip]} />}
      </InputContainer>
    </Container>
  );
};

export default TextInput;

const Container = styled.div`
  position: relative;
`;

const InputContainer = styled.div<{
  status?: string;
  focused?: string;
  padding?: string;
  disabled?: string;
}>`
  width: 100%;
  padding: ${(props) => (props.padding ? props.padding : "1rem")};
  border: 1px solid
    ${(props) =>
      props.focused === "true"
        ? Colors.primary
        : props.disabled === "true"
        ? Colors.grey600
        : props.status === "error"
        ? Colors.danger
        : Colors.grey500};
  border-radius: 0.8rem;
  transition: ease all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Input = styled.input<{ status?: string; icon?: string }>`
  font-family: "Switzer", sans-serif;
  width: ${(props) => (props.icon === "true" ? "90%" : "100%")};
  outline: none;
  background: none;
  border: none;
  color: ${Colors.white200};
  font-family: "Inter", sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6rem;

  &:disabled {
    color: ${Colors.grey600};
  }
  &::placeholder {
    color: ${Colors.grey500};
  }
`;
